<template>
  <section class="home">
    <za-banner :bg="bannerBg"></za-banner>
    <article class="article">
      <section class="article-inner">
        <template v-for="(item, index) in reportsList">
          <div :id="item.id" class="article-item" :key="index">
              <img class="article-item-img" :src="item.img" alt="">
              <div class="item-right">
                <h2 class="article-item-title">{{item.title}}</h2>
                <p class="article-item-desc">{{item.desc}}</p>
              </div>
          </div>
        </template>
      </section>
    </article>
  </section>
</template>

<script>
import zaBanner from '@/components/Banner.vue'
export default {
  components: {
    zaBanner
  },
  data () {
    return {
      bannerBg: require('../assets/banner.png'),
      reportsList: [{
        id: 'part1',
        img: require('../assets/part1.png'),
        title: '轻量级远程工具',
        desc: '手机可用的远程办公工具，拥有 Windows、Android、Linux 系统，每个人都可以在系统中按需使用自己的摄像头、麦克风、拥有自己的画笔、桌面文件夹等。'
      }, {
        id: 'part2',
        img: require('../assets/part2.png'),
        title: '颠覆传统操作方式 ',
        desc: '你可以自由安装和运行任何应用程序。值得一提的是，远程控制电脑可以持远程关机、注销、重启等。如果你经常在家中懒得起身用电脑，这款产品太适合你了。'
      }, {
        id: 'part3',
        img: require('../assets/part3.png'),
        title: '远程访问你的文件夹 ',
        desc: '很酷的云文件夹，支持远程访问Windows、Android、Linux三个平台，让文件夹时刻在云端，当然这个云端其实就是你自己的私人电脑。'
      }]
    }
  },
  methods: {
    toLogin() {
      this.$router.push('./login')
    }
  }
}
</script>
<style scoped>
.article {
  min-width: 1200px;
  width: 100%;
  margin: 0 auto;
}
.article-title {
  font-size: 36px;
  text-align: center;
}
.article-inner {
  font-size: 18px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.article-item {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px;
  width: 100%;
}
.article-item:nth-child(2) {
  flex-flow: row-reverse;
}
.article-item-cover {
  width: 202px;
  height: 160px;
  padding: 12px;
  color: rgba(255, 255, 255, .7);
  background-image: url('../assets/cardBg.png');
}
.article-item-title {
  width: 100%;
  margin: 20px 0;
  color: #000;
  text-align: left;
  font-size: 26px;
}
.article-item-desc {
  font-size: 14px;
  line-height: 30px;
  color: #333;
  width: 100%;
  text-align: left;
}
.more-link {
  text-align: center;
}
.more-link a {
  font-size: 18px;
  height: 27px;
  line-height: 27px;
  display: inline-block;
  color: #016091;
  padding-bottom: 1px;
}
.more-link a:hover {
  border-bottom: 1px solid #016091;
}
.more-link a span {
  font-weight: 700;
}
.sub-title {
  margin: 50px;
  text-align: center;
}
.item-right {
  display: inline-block;
  width: 350px;
  margin: 30px 50px;
  text-align: center;
}
.article-item-img {
  width: 381px;
  height: auto;
}
</style>